import { Component, inject, Input, OnInit } from '@angular/core';
import { VariablesGlobalesService } from '../../services/variables-globales.service';
import { EncriptarService } from '../../services/encriptar.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { eTipoGrupo, eTipoLineaMovimientos, eTipoMovimiento, enumFormasPago, enumPerfilAcceso, enumSegmentTipoDocumento, enumTipoDocumento, enumTipoOperacion, eTipoModalidadFacturas } from '../../../GlobalConf';
import { AgenteGestionCabeceraDTO, AgenteGestionLineaDTO, AlbaranDTO, ArticuloDocumentoApp, DocumentoDTO, EstadoEntidadAsignacionDTO, FacturaDTO, FacturaSimplificadaDTO, MovimientoANSDTO, MovimientoDTO, PedidoDTO, PresupuestoDTO } from 'src/app/Models/ApiV2/DocumentoDTO';
import { DocumentoApp } from '../../Models/ApiV2/DocumentoDTO';
import { DomicilioGestionDTO } from 'src/app/Models/ApiV2/Terceros';
import { DocumentosErpService } from 'src/app/services/API_ALO/documentosErp.service';
import { AMRespuestaPOSTPUT } from 'src/app/Models/RespuestaPOSTPUT/AMRespuestaPOSTPUT';
import { CalculosDocumentosService } from 'src/app/services/calculos-documentos.service';
import { ErpService } from 'src/app/services/API_ALO/erp.service';
import { FormaPagoDTO } from 'src/app/Models/ApiV2/FormaPagoDTO';
import { AMRespuestaGET } from 'src/app/Models/RespuestaGET/AMRespuestaGET';
import { ArticuloDTO } from 'src/app/Models/ApiV2/ArticuloDTO';
import { TiposIvaDTO } from 'src/app/Models/ApiV2/TiposIvaDTO';
import { TipoIvaGestionDTO } from 'src/app/Models/ApiV2/TipoIvaGestionDTO';
import { TiposRetencionDTO } from 'src/app/Models/ApiV2/TiposRetencionDTO';
import { TipoIrpfGestionDTO } from 'src/app/Models/ApiV2/TipoIrpfGestionDTO';
import { EntidadCodigoStringDTO } from 'src/app/Models/ApiV2/EntidadCodigoStringDTO';
import { Router } from '@angular/router';
import { CurrencyPipe, NgClass, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { ProcesosGlobalesService } from 'src/app/services/procesos-globales.service';
import { IonGrid, IonHeader, IonRow, IonCol, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonContent, IonDatetimeButton, IonSelect,
         IonSelectOption, IonItem, IonInput, IonChip, IonFooter, IonModal, IonDatetime, ModalController, AlertController, ToastController, LoadingController, IonLabel } from "@ionic/angular/standalone";
import { InputAutonumericComponent } from '../input-autonumeric/input-autonumeric.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ListaArticulosComponent } from '../lista-articulos/lista-articulos.component';
import { MapeosService } from 'src/app/services/Mapeos.service';
import { addIcons} from 'ionicons';
import { close, pencil,checkmark, informationCircleOutline, add, warning, trash } from 'ionicons/icons';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { MbscDatepickerModule, MbscDatepickerControl } from '@mobiscroll/angular';
import { localeEs } from '@mobiscroll/angular';



@Component({
    selector: 'app-carrito',
    templateUrl: './carrito.component.html',
    styleUrls: ['./carrito.component.scss'],
    providers: [TitleCasePipe],
    standalone: true,
    imports : [
      IonHeader, IonGrid, IonRow, IonCol, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonContent, IonDatetimeButton,
      IonSelect, IonSelectOption, IonItem, IonInput, IonChip, IonFooter, IonModal, IonDatetime,
      TitleCasePipe, CurrencyPipe, UpperCasePipe,  NgClass, KENDO_DROPDOWNS, IonLabel, MbscDatepickerModule,
      TranslateModule,
      InputAutonumericComponent,
      FormsModule,
      ReactiveFormsModule,
      ListaArticulosComponent
    ]
})
export class CarritoComponent implements OnInit {
  variablesGlobales = inject(VariablesGlobalesService);
  servicioEncriptar = inject(EncriptarService);
  alertCtrl = inject(AlertController);
  translate = inject(TranslateService);
  documentosErpService = inject(DocumentosErpService);
  servicioCalculos = inject(CalculosDocumentosService);
  private toastController = inject(ToastController);
  erpService = inject(ErpService);
  calculosService = inject(CalculosDocumentosService);
  loadingCtrl = inject(LoadingController);
  private router = inject(Router);
  private titlecasePipe = inject(TitleCasePipe);
  procesosGlobales = inject(ProcesosGlobalesService);
  mapeosService = inject(MapeosService);

  @Input() documentoApp: DocumentoApp
  arrayEdicionLinea: Boolean[]
  totalBruto: number = 0;
  retenciones: number = 0;
  importeDescuento: number = 0;
  total: number = 0;
  bases: number = 0;
  aPagar: number = 0;
  iva: number = 0;
  recargo: number = 0;
  mostrarLineaObservaciones:boolean = false
  lineaObservacionesStr: string;
  keys(): Array<string> {
    var keys = Object.keys(enumFormasPago);
    return keys.slice(keys.length / 2);
  }
  fechaPrevista
  fechaDocumento
  listaFormasPago: FormaPagoDTO[];
  formaPagoSeleccionada: FormaPagoDTO = null;
  documentoDTO: DocumentoDTO
  enumTipoDocumento
  eTipoLineaMovimientos
  enumTipoOperacion
  myControl: MbscDatepickerControl[] = ['calendar']
  public localeEs = localeEs;
  eTipoModalidadFacturas

 public modalCtrl = inject(ModalController);

 seleccionarArticuloAbierto: boolean = false;

 edicionDocumento: boolean = false;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    this.enumTipoDocumento = enumTipoDocumento
    this.enumTipoOperacion = eTipoGrupo
    this.eTipoLineaMovimientos = eTipoLineaMovimientos
    this.eTipoModalidadFacturas = eTipoModalidadFacturas
    this.seleccionarArticuloAbierto = false;
    addIcons({close,trash,pencil,checkmark,informationCircleOutline,add,warning});
  }

  async ngOnInit() {
    if(this.documentoApp.documentoALO != null){
      this.edicionDocumento = true
    }
    this.arrayEdicionLinea = []
    for (let i = 0; i < this.documentoApp.listaArticulos.length; i++) {
      this.arrayEdicionLinea.push(false);
    }

    await this.cargarFormasPagoALO();
    if(this.documentoApp.documentoALO != null){
      this.fechaPrevista = new Date(this.documentoApp.documentoALO.fecha).toISOString();
    }else {
      this.fechaPrevista = new Date().toISOString();
    }
    this.fechaDocumento = new Date(this.documentoApp.fecha).toISOString();
    console.log('Documentos en carrito: ', this.documentoApp);
    await this.actualizarDocumentoDTO();
  }

  async cargarFormasPagoALO() {
    await this.erpService.obtenerFormasPagoAlo(null).toPromise().then(async (resAM: AMRespuestaGET) => {
      console.log({ resAM })
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {
          this.listaFormasPago = resAM.data
          console.log('this.formasPagoDisponibles', this.listaFormasPago);
          if(this.edicionDocumento && this.documentoApp?.documentoALO?.formaPago){
            this.formaPagoSeleccionada = this.listaFormasPago.find(formaPago => formaPago.id == this.documentoApp.documentoALO?.formaPago?.id)
          }else {
            this.formaPagoSeleccionada = this.listaFormasPago.find(formaPago => formaPago.id == this.documentoApp.tercero?.formaPago?.id)
          }
          console.log('this.formaPagoDefecto: ',this.formaPagoSeleccionada);
          if (!this.formaPagoSeleccionada) {
            this.formaPagoSeleccionada = this.listaFormasPago[0]
            console.log('this.formaPagoDefecto: ',this.formaPagoSeleccionada);

          }
        } else {
          this.listaFormasPago = []
        }
      } else {
        console.error('Error al cargar formas de pago de ALO. Status: ', resAM.status, ' message: ', resAM.message)
        this.listaFormasPago = []
      }
    })
      .catch(async error => {
        console.error('Error al cargar formas de pago de ALO. ERROR: ', error)
        this.listaFormasPago = []
      })
  }

  async actualizarDocumentoDTO() {
    await this.documentoAppToDocumentoDTO(this.documentoApp).then(async (documentoDTO: DocumentoDTO) => {
      console.log('documentoAppToDocumentoDTO: ', documentoDTO);
      this.documentoDTO = documentoDTO
      await this.calculosService.calcularTotalesDocumento(this.documentoDTO, eTipoGrupo.CL).then(documentoCaluclado => {
        console.log('DocumentoCalculado: ', JSON.stringify(documentoCaluclado));
        this.documentoDTO = documentoCaluclado
        for (let i = 0; i < this.documentoApp.listaArticulos.length; i++) {
          this.documentoApp.listaArticulos[i].precioPredeterminado = this.documentoDTO.movimientos[i].precio;
          this.documentoApp.listaArticulos[i].precioPredeterminadoIva = this.documentoDTO.movimientos[i].precioConIva;
        }
      });
    })
    this.servicioEncriptar.guardarEnStorage('documentoActual', JSON.stringify(this.variablesGlobales.documentoActual));
  }

  async borrarDocumento() {
    let headerBorrar: string;
    let subHeaderBorrar: string;
    let messageBorrar: string;
    let btnCancelar: string;
    let btnBorrar: string;
    console.log('No hay documento en curso seleccionar cliente.');
    if (this.documentoApp.tipo == enumTipoDocumento.PED && !this.edicionDocumento) {
      await this.translate.get('carrito.alertBorrarPedido.headerBorrar').toPromise().then((resHeaderBorrar: string) => {
        headerBorrar = resHeaderBorrar
      })
      await this.translate.get('carrito.alertBorrarPedido.mesaageBorrar').toPromise().then((resMessageBorrar: string) => {
        messageBorrar = resMessageBorrar
      })
      await this.translate.get('carrito.alertBorrarPedido.btnCancelar').toPromise().then((resBtnCancelar: string) => {
        btnCancelar = resBtnCancelar
      })
      await this.translate.get('carrito.alertBorrarPedido.btnBorrar').toPromise().then((resBtnBorrar: string) => {
        btnBorrar = resBtnBorrar
      })
    } else if(this.documentoApp.tipo == enumTipoDocumento.FAC && !this.edicionDocumento){
      await this.translate.get('carrito.alertBorrarFactura.headerBorrar').toPromise().then((resHeaderBorrar: string) => {
        headerBorrar = resHeaderBorrar
      })
      await this.translate.get('carrito.alertBorrarFactura.mesaageBorrar').toPromise().then((resMessageBorrar: string) => {
        messageBorrar = resMessageBorrar
      })
      await this.translate.get('carrito.alertBorrarFactura.btnCancelar').toPromise().then((resBtnCancelar: string) => {
        btnCancelar = resBtnCancelar
      })
      await this.translate.get('carrito.alertBorrarFactura.btnBorrar').toPromise().then((resBtnBorrar: string) => {
        btnBorrar = resBtnBorrar
      })
    } else if(this.documentoApp.tipo == enumTipoDocumento.ALB && !this.edicionDocumento){
      await this.translate.get('carrito.alertBorrarAlbaran.headerBorrar').toPromise().then((resHeaderBorrar: string) => {
        headerBorrar = resHeaderBorrar
      })
      await this.translate.get('carrito.alertBorrarAlbaran.mesaageBorrar').toPromise().then((resMessageBorrar: string) => {
        messageBorrar = resMessageBorrar
      })
      await this.translate.get('carrito.alertBorrarAlbaran.btnCancelar').toPromise().then((resBtnCancelar: string) => {
        btnCancelar = resBtnCancelar
      })
      await this.translate.get('carrito.alertBorrarAlbaran.btnBorrar').toPromise().then((resBtnBorrar: string) => {
        btnBorrar = resBtnBorrar
      })
    } else if(this.documentoApp.tipo == enumTipoDocumento.PRE && !this.edicionDocumento){
      await this.translate.get('carrito.alertBorrarPresupuesto.headerBorrar').toPromise().then((resHeaderBorrar: string) => {
        headerBorrar = resHeaderBorrar
      })
      await this.translate.get('carrito.alertBorrarPresupuesto.mesaageBorrar').toPromise().then((resMessageBorrar: string) => {
        messageBorrar = resMessageBorrar
      })
      await this.translate.get('carrito.alertBorrarPresupuesto.btnCancelar').toPromise().then((resBtnCancelar: string) => {
        btnCancelar = resBtnCancelar
      })
      await this.translate.get('carrito.alertBorrarPresupuesto.btnBorrar').toPromise().then((resBtnBorrar: string) => {
        btnBorrar = resBtnBorrar
      })
    }else if (this.edicionDocumento){
      await this.translate.get('carrito.alertBorrarEdicion.headerBorrar').toPromise().then((resHeaderBorrar: string) => {
        headerBorrar = resHeaderBorrar
      })
      await this.translate.get('carrito.alertBorrarEdicion.mesaageBorrar').toPromise().then((resMessageBorrar: string) => {
        messageBorrar = resMessageBorrar
      })
      await this.translate.get('carrito.alertBorrarEdicion.btnCerrar').toPromise().then((resBtnCancelar: string) => {
        btnCancelar = resBtnCancelar
      })
      await this.translate.get('carrito.alertBorrarEdicion.btnCancelarEdicion').toPromise().then((resBtnBorrar: string) => {
        btnBorrar = resBtnBorrar
      })
    }
    const alert = await this.alertCtrl.create({
      mode: 'ios',
      header: this.titlecasePipe.transform(headerBorrar),
      message: this.titlecasePipe.transform(messageBorrar),
      buttons: [
        {
          text: this.titlecasePipe.transform(btnCancelar),
          role: 'cancel',
        }, {
          text: this.titlecasePipe.transform(btnBorrar),
          cssClass: 'btnRojoAlerts',
          handler: async () => {
            console.log('Borrar documento actual');
            await this.servicioEncriptar.eliminarLocalStorage('documentoActual')
            this.variablesGlobales.documentoEnCurso = false
            this.variablesGlobales.documentoActual = null
            await this.modalCtrl.dismiss()
          }
        }
      ]
    });

    await alert.present();
  }

  inputValido(articuloDocumentoApp: ArticuloDocumentoApp): boolean {
    if (articuloDocumentoApp.numUnidades != null) {
      if (articuloDocumentoApp.numUnidades > 0) {
        var text = articuloDocumentoApp.numUnidades.toString();
        var indexPunto = text.indexOf(".");
        let numDecimalesInput = text.length - indexPunto - 1
        if (numDecimalesInput > parseInt(this.variablesGlobales.DecimalesEnUnidades)) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }

    }
    return false
  }

  inputPrecioValido(precioLinea): boolean {
    if (!precioLinea) {
      precioLinea = 0
    }
    let precioTxt = precioLinea?.toString();
    var indexPunto = precioTxt?.indexOf(".");
    if (indexPunto > 0) {
      let numDecimalesInput = precioTxt.length - indexPunto - 1
      if (numDecimalesInput > parseInt(this.variablesGlobales.DecimalesEnMoneda)) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  inputDescuentoValido(descuentoLinea): boolean {
    let descuentoTxt = descuentoLinea?.toString();
    var indexPunto = descuentoTxt?.indexOf(".");
    if (indexPunto > 0) {
      let numDecimalesInput = descuentoTxt.length - indexPunto - 1
      if (numDecimalesInput > parseInt(this.variablesGlobales.DecimalesEnUnidades)) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  async eliminarArticuloCarrito(index: number) {
    this.documentoApp.listaArticulos.splice(index, 1)
    this.variablesGlobales.documentoActual = this.documentoApp
    this.servicioEncriptar.guardarEnStorage('documentoActual', JSON.stringify(this.variablesGlobales.documentoActual));
    await this.actualizarDocumentoDTO();
  }

  async unidadesCambiadas(event,articulo) {
    articulo.numUnidades = event.numUnidades
    let [tarifaPrecioArticulo,precioEspecial] = await this.procesosGlobales.obtenerTarifaPrecioArticulo(articulo.articulo,this.variablesGlobales.documentoActual.tipoOperacion, this.variablesGlobales.documentoActual.tarifaPrecioPredeterminada, this.variablesGlobales.documentoActual.tercero, new Date(this.variablesGlobales.documentoActual.fecha),articulo.numUnidades);
    if(precioEspecial){
      articulo.precioPredeterminadoIva = null;
      articulo.precioPredeterminado = null;
      if(this.documentoApp.serie.ivaIncluido){
        articulo.precioEspecialIva = tarifaPrecioArticulo?.precio ?? 0
        articulo.precioEspecial = null
      }else{
        articulo.precioEspecial = tarifaPrecioArticulo?.precio ?? 0
        articulo.precioEspecialIva = null
      }
    }else {
      articulo.precioEspecialIva = null;
      articulo.precioEspecial = null;
      if(this.documentoApp.serie.ivaIncluido){
        articulo.precioPredeterminadoIva = tarifaPrecioArticulo?.precio ?? 0
        articulo.precioPredeterminado = null
      }else{
        articulo.precioPredeterminado = tarifaPrecioArticulo?.precio ?? 0
        articulo.precioPredeterminadoIva = null
      }
    }

    let [tarifaDescuentoArticulo,descuentoEspecial] = await this.procesosGlobales.obtenerTarifaDescuentoArticulo(articulo.articulo,this.variablesGlobales.documentoActual.tarifaDescuentoPredeterminada,this.variablesGlobales.documentoActual.tercero, new Date(this.variablesGlobales.documentoActual.fecha), articulo.numUnidades);
    if(descuentoEspecial){
      articulo.descuentoPredeterminado = null;
      articulo.descuentoEspecial = tarifaDescuentoArticulo?.descuento1
    }else{
      articulo.descuentoEspecial = null;
      articulo.descuentoPredeterminado = tarifaDescuentoArticulo?.descuento1 ?? 0
    }

    this.variablesGlobales.documentoActual = this.documentoApp
    await this.actualizarDocumentoDTO();
  }

  async editarLinea(articuloLinea: ArticuloDocumentoApp, indexArticuloEditar: number) {
    let modalEditarLinea
    modalEditarLinea = await this.modalCtrl.create({
      component: (await import('../modal-editar-linea/modal-editar-linea.component')).ModalEditarLineaComponent,
      mode: 'ios',
      cssClass: 'modalEditarLinea',
      componentProps: {
        articulo: articuloLinea
      }
    });
    await modalEditarLinea.present();
    modalEditarLinea.onDidDismiss().then(data => {
      if (data.data) {
        console.log('Cerrado modal con data: ', data);
        if (data.data.precio) {
          articuloLinea.precioPredeterminadoIva = data.data.precio;
          articuloLinea.precioPredeterminado = null;
          articuloLinea.precioEspecial = null;
          articuloLinea.precioEspecialIva = null;
        }
        if (data.data.descuento) {
          articuloLinea.descuentoPredeterminado = data.data.descuento;
          articuloLinea.descuentoEspecial = null;
        }

      } else {
        console.log('Cerrado modal editar linea');
      }

    })
  }

  modificarLinea(index: number, articuloLinea: ArticuloDocumentoApp){
    this.arrayEdicionLinea[index] ? this.arrayEdicionLinea[index] = false : this.arrayEdicionLinea[index] = true;
    if(articuloLinea.precioEspecial){
      articuloLinea.precioPredeterminado = articuloLinea.precioEspecial;
      articuloLinea.precioPredeterminadoIva = null;
      articuloLinea.precioEspecial = null;
      articuloLinea.precioEspecialIva = null;
    } else if (articuloLinea.precioEspecialIva){
      articuloLinea.precioPredeterminadoIva = articuloLinea.precioEspecialIva;
      articuloLinea.precioPredeterminado = null;
      articuloLinea.precioEspecial = null;
      articuloLinea.precioEspecialIva = null;
    }
    if(articuloLinea.descuentoEspecial){
      articuloLinea.descuentoPredeterminado = articuloLinea.descuentoEspecial;
      articuloLinea.descuentoEspecial = null
    }
    this.actualizarDocumentoDTO();
  }

  handleInputDescuentoChange(articulo:ArticuloDocumentoApp, event){
    if (event === null || event === '') {
      articulo.descuentoPredeterminado = 0;
      articulo.descuentoEspecial = null
    } else {
      articulo.descuentoPredeterminado = event;
      articulo.descuentoEspecial = null
    }
  }

  handleInputPrecioChange(articulo:ArticuloDocumentoApp, event, iva:boolean){
    if (event === null || event === '') {
      if(iva){
        articulo.precioPredeterminadoIva = 0;
        articulo.precioPredeterminado = null;
        articulo.precioEspecialIva = null;
        articulo.precioEspecial = null;

      }else{
        articulo.precioPredeterminado = 0;
        articulo.precioPredeterminadoIva = null;
        articulo.precioEspecialIva = null;
        articulo.precioEspecial = null;
      }

    } else {
      if(iva){
        articulo.precioPredeterminadoIva = event;
        articulo.precioPredeterminado = null;
        articulo.precioEspecialIva = null;
        articulo.precioEspecial = null;

      }else{
        articulo.precioPredeterminado = event;
        articulo.precioPredeterminadoIva = null;
        articulo.precioEspecialIva = null;
        articulo.precioEspecial = null;
      }

    }
  }
  async editorDescuentoGeneralDocumento(event){
    await this.actualizarDocumentoDTO();
  }

  loteCambiado(event, index){
    //console.log({event});
    //console.log('index: ',index);
    let nuevoLoteSeleccionado = this.documentoApp.listaArticulos[index].listaLotes.find(lote => lote.id == event.detail.value)
    this.documentoApp.listaArticulos[index].lote = nuevoLoteSeleccionado
  }

  formaPagoCambiada(event){
    this.formaPagoSeleccionada = this.listaFormasPago.find((formaPago) => formaPago.id == event.detail.value);
    console.log('Forma Pago Cambiada: ',this.formaPagoSeleccionada);
  }

  async fechaDocumentoCambiada($event){
    this.documentoApp.fecha = this.fechaDocumento
    console.log('this.documentoApp.fecha: ',this.documentoApp.fecha);

    for (let i = 0; i < this.documentoApp.listaArticulos.length; i++) {
      let [tarifaPrecioArticulo,precioEspecial] = await this.procesosGlobales.obtenerTarifaPrecioArticulo(this.documentoApp.listaArticulos[i].articulo,this.variablesGlobales.documentoActual.tipoOperacion, this.variablesGlobales.documentoActual.tarifaPrecioPredeterminada, this.variablesGlobales.documentoActual.tercero, new Date(this.variablesGlobales.documentoActual.fecha),this.documentoApp.listaArticulos[i].numUnidades);
      if(precioEspecial){
        this.documentoApp.listaArticulos[i].precioPredeterminadoIva = null;
        this.documentoApp.listaArticulos[i].precioPredeterminado = null;
        if(this.documentoApp.serie.ivaIncluido){
          this.documentoApp.listaArticulos[i].precioEspecialIva = tarifaPrecioArticulo?.precio ?? 0
          this.documentoApp.listaArticulos[i].precioEspecial = null
        }else{
          this.documentoApp.listaArticulos[i].precioEspecial = tarifaPrecioArticulo?.precio ?? 0
          this.documentoApp.listaArticulos[i].precioEspecialIva = null
        }
      }else {
        this.documentoApp.listaArticulos[i].precioEspecialIva = null;
        this.documentoApp.listaArticulos[i].precioEspecial = null;
        if(this.documentoApp.serie.ivaIncluido){
          this.documentoApp.listaArticulos[i].precioPredeterminadoIva = tarifaPrecioArticulo?.precio ?? 0
          this.documentoApp.listaArticulos[i].precioPredeterminado = null
        }else{
          this.documentoApp.listaArticulos[i].precioPredeterminado = tarifaPrecioArticulo?.precio ?? 0
          this.documentoApp.listaArticulos[i].precioPredeterminadoIva = null
        }
      }

      let [tarifaDescuentoArticulo,descuentoEspecial] = await this.procesosGlobales.obtenerTarifaDescuentoArticulo(this.documentoApp.listaArticulos[i].articulo,this.variablesGlobales.documentoActual.tarifaDescuentoPredeterminada,this.variablesGlobales.documentoActual.tercero, new Date(this.variablesGlobales.documentoActual.fecha), this.documentoApp.listaArticulos[i].numUnidades);
      if(descuentoEspecial){
        this.documentoApp.listaArticulos[i].descuentoPredeterminado = null;
        this.documentoApp.listaArticulos[i].descuentoEspecial = tarifaDescuentoArticulo?.descuento1 ?? 0
      }else{
        this.documentoApp.listaArticulos[i].descuentoEspecial = null;
        this.documentoApp.listaArticulos[i].descuentoPredeterminado = tarifaDescuentoArticulo?.descuento1 ?? 0
      }

    }
    await this.actualizarDocumentoDTO();
  }
  async documentoAppToDocumentoDTO(documentoApp: DocumentoApp): Promise<DocumentoDTO> {
    let documentoDTO: DocumentoDTO = new DocumentoDTO();
    documentoDTO.id = documentoApp.documentoALO?.id;
    documentoDTO.tipo = documentoApp.tipo
    //documentoDTO.modalidad = 0//Ho hay que psarlo, Juanma me ha dicho que esto se le pasa solo cuando la serie es del tipo "Regimen de bienes usados"
    documentoDTO.fecha = documentoApp.fecha;
    documentoDTO.hora = documentoApp.fecha;
    documentoDTO.nombre = documentoApp.tercero.datosFiscales?.nombre;
    documentoDTO.nif = documentoApp.tercero.datosFiscales?.nif;
    documentoDTO.nifRepresentante = documentoApp.tercero.datosFiscales?.nifRepresentante;
    documentoDTO.fechaDocumento = documentoApp.fecha;
    documentoDTO.actividad = 1;//SE PONE 1 POR DEFECTO
    documentoDTO.iva = documentoApp.tercero.iva
    documentoDTO.ivaIncluido = +documentoApp.serie.ivaIncluido
    documentoDTO.regimenFiscal = documentoApp.tercero?.modalidadFiscal;
    documentoDTO.fechaValor = documentoApp.fecha;

    if(this.edicionDocumento){
      documentoDTO.descuento1 = documentoApp.documentoALO.descuento1 ?? 0;
      documentoDTO.descuento2 = documentoApp.documentoALO.descuento2 ?? 0;
      documentoDTO.descuento3 = documentoApp.documentoALO.descuento3 ?? 0;
      documentoDTO.descuento4 = documentoApp.documentoALO.descuento4 ?? 0;
    }else {
      documentoDTO.descuento1 = Array.isArray(documentoApp.tercero?.condicionesEconomicas) ? documentoApp.tercero.condicionesEconomicas[0]?.descuento1 ?? 0 : 0;
      documentoDTO.descuento2 = Array.isArray(documentoApp.tercero?.condicionesEconomicas) ? documentoApp.tercero.condicionesEconomicas[0]?.descuento2 ?? 0 : 0;
      documentoDTO.descuento3 = Array.isArray(documentoApp.tercero?.condicionesEconomicas) ? documentoApp.tercero.condicionesEconomicas[0]?.descuento3 ?? 0 : 0;
      documentoDTO.descuento4 = Array.isArray(documentoApp.tercero?.condicionesEconomicas) ? documentoApp.tercero.condicionesEconomicas[0]?.descuento4 ?? 0 : 0;
    }
    documentoDTO.peso = await this.servicioCalculos.calcularPesoCabecera(documentoApp.listaArticulos);
    documentoDTO.bultos = await this.servicioCalculos.calcularBultosCabecera(documentoApp.listaArticulos);
    documentoDTO.importeDescuento1 = 0;
    documentoDTO.importeDescuento2 = 0;
    documentoDTO.importeDescuento3 = 0;
    documentoDTO.importeDescuento4 = 0;
    documentoDTO.totalBruto = 0;
    documentoDTO.totalBases = 0;
    documentoDTO.totalIVA = 0;
    documentoDTO.totalRecargo = 0;
    documentoDTO.totalDocumento = 0;
    documentoDTO.totalCargosFinal = 0;
    documentoDTO.totalAbonosFinal = 0;
    documentoDTO.totalRetenciones = 0;
    documentoDTO.totalAPagar = 0;
    if(this.edicionDocumento){
      documentoDTO.fechaPrevista = documentoApp.documentoALO.fechaPrevista
      documentoDTO.fechaPrevistaEntrega = documentoApp.documentoALO.fechaPrevistaEntrega
    }else {
      documentoDTO.fechaPrevista = this.fechaPrevista
      documentoDTO.fechaPrevistaEntrega = this.fechaPrevista
    }


    //Añadimos movimientos
    documentoDTO.movimientos = []
    for (let i = 0; i < documentoApp.listaArticulos.length; i++) {
      let movimientoALO: MovimientoDTO = new MovimientoDTO();
      if(documentoApp.listaArticulos[i].tipoLinea == eTipoLineaMovimientos.NORMAL){
        if(documentoApp.listaArticulos[i].articulo.plantillaLotes && documentoApp?.tipo == enumTipoDocumento.FAC){
          movimientoALO.movimientosArticulosNumerosSerie = []
          let movimientoNumeroSerie: MovimientoANSDTO = new MovimientoANSDTO();
          movimientoNumeroSerie.articuloNumeroSerie = { id: documentoApp.listaArticulos[i].lote.id}
          movimientoNumeroSerie.unidad1 = documentoApp.listaArticulos[i].numUnidades
          movimientoALO.movimientosArticulosNumerosSerie.push(movimientoNumeroSerie);
        }
        if(this.edicionDocumento){
          movimientoALO.agentes = documentoApp.documentoALO.movimientos[i]?.agentes
        }else {
          if(this.variablesGlobales.perfilAcceso == enumPerfilAcceso.VENDEDOR){
            movimientoALO.agentes = []
            let agenteMovimientoDTO: AgenteGestionLineaDTO = new AgenteGestionLineaDTO();
            //agenteMovimientoDTO.comisionCantidad = 1;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
            //agenteMovimientoDTO.nivel = 1;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
            agenteMovimientoDTO.agente = { id: this.variablesGlobales.vendedorActual.id };
            movimientoALO.agentes.push(agenteMovimientoDTO);
          }else if (this.variablesGlobales.perfilAcceso == enumPerfilAcceso.USUARIO || this.variablesGlobales.perfilAcceso == enumPerfilAcceso.EMPRESA){
            if(this.documentoApp?.tercero?.vendedores && this.documentoApp?.tercero?.vendedores.length >0){
              movimientoALO.agentes = [];
              for (let i = 0; i < this.documentoApp?.tercero?.vendedores.length; i++) {
                let agenteMovimientoDTO: AgenteGestionLineaDTO = new AgenteGestionLineaDTO();
                //agenteMovimientoDTO.comisionCantidad = 1;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
                //agenteMovimientoDTO.nivel = 1;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
                agenteMovimientoDTO.agente = { id: this.documentoApp?.tercero?.vendedores[i]?.agente?.id };
                movimientoALO.agentes.push(agenteMovimientoDTO);
              }
            }
          }
        }

        //agenteMovimientoDTO.comisionPorcentaje = 2;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
        //agenteMovimientoDTO.importeComisionFija = 3;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO

        movimientoALO.regimenFiscal = documentoApp.tercero.modalidadFiscal;
        movimientoALO.tipoMovimiento = eTipoMovimiento.SalidasClientes
        movimientoALO.tipoLinea = eTipoLineaMovimientos.NORMAL
        movimientoALO.actividad = 1;//Se pone por defecto
        movimientoALO.articulo = documentoApp.listaArticulos[i].articulo;
        movimientoALO.articuloAlmacen = { id: documentoApp.listaArticulos[i].articulo.id };
        if(this.edicionDocumento){
          movimientoALO.tipoTarifaPrecios = documentoApp?.documentoALO?.movimientos[i]?.tipoTarifaPrecios
          movimientoALO.tipoTarifaDescuentos = documentoApp?.documentoALO?.movimientos[i]?.tipoTarifaDescuentos
        }else{
          if(Array.isArray(this.documentoApp.tercero?.condicionesEconomicas) && documentoApp.tercero?.condicionesEconomicas[0]?.tarifaPrecios){
            movimientoALO.tipoTarifaPrecios = new EntidadCodigoStringDTO()
            movimientoALO.tipoTarifaPrecios.id = documentoApp.tercero?.condicionesEconomicas[0]?.tarifaPrecios?.id;
          }
          if(Array.isArray(this.documentoApp.tercero?.condicionesEconomicas) && documentoApp.tercero?.condicionesEconomicas[0]?.tarifaDescuentos){
            movimientoALO.tipoTarifaDescuentos = new EntidadCodigoStringDTO()
            movimientoALO.tipoTarifaDescuentos.id = documentoApp.tercero?.condicionesEconomicas[0]?.tarifaDescuentos?.id;
          }
        }

        movimientoALO.almacen = documentoApp.almacen;

        let tipoIva: TiposIvaDTO = await this.obtenerTipoIva(documentoApp.listaArticulos[i].articulo, new Date(documentoApp.fecha))
        movimientoALO.tipoIva = new TipoIvaGestionDTO();
        movimientoALO.tipoIva.id = tipoIva.id;
        movimientoALO.tipoIva.codigo = tipoIva.codigo;
        movimientoALO.tipoIva.exento = tipoIva.exento;
        movimientoALO.tipoIva.guidRegistro = tipoIva.guidRegistro;
        movimientoALO.tipoIva.porcentajeIva = tipoIva.iva;
        movimientoALO.tipoIva.porcentajeRecargo = tipoIva.recargo;

        let tipoIrpf: TiposRetencionDTO = await this.obtenerTipoRetencion(documentoApp.listaArticulos[i].articulo, new Date(documentoApp.fecha))
        if (tipoIrpf) {
          movimientoALO.tipoIrpf = new TipoIrpfGestionDTO();
          movimientoALO.tipoIrpf.id = tipoIrpf.id;
          movimientoALO.tipoIrpf.codigo = tipoIrpf.codigo;
          movimientoALO.tipoIrpf.guidRegistro = tipoIrpf.guidRegistro;
          movimientoALO.tipoIrpf.porcentaje = tipoIrpf.porcentaje;
        }

        movimientoALO.tipoOperacion = documentoApp.listaArticulos[i].articulo.tipoOperacion
        if (documentoApp.listaArticulos[i].articulo?.nombre) {
          movimientoALO.descripcion = documentoApp.listaArticulos[i].articulo.nombre
        } else {
          movimientoALO.descripcion = documentoApp.listaArticulos[i].articulo?.descripcionAmpliada
        }
        movimientoALO.unidad1 = documentoApp.listaArticulos[i].numUnidades
        movimientoALO.peso = documentoApp.listaArticulos[i].articulo.peso
        movimientoALO.volumen = documentoApp.listaArticulos[i].articulo.volumen1
        if (documentoApp.listaArticulos[i].descuentoEspecial){
          movimientoALO.descuento1 = documentoApp.listaArticulos[i].descuentoEspecial
        }else {
          movimientoALO.descuento1 = documentoApp.listaArticulos[i].descuentoPredeterminado
        }
        movimientoALO.descuento2 = 0;
        movimientoALO.descuento3 = 0;

        if (documentoApp.listaArticulos[i].precioPredeterminadoIva != null) {
          movimientoALO.precioConIva = documentoApp.listaArticulos[i].precioPredeterminadoIva
          movimientoALO.precio = (documentoApp.listaArticulos[i].precioPredeterminadoIva / (1 + (await this.obtenerTipoIva(documentoApp.listaArticulos[i].articulo, new Date(documentoApp.fecha)).iva / 100)))//HAY QUE CALCULARLO
        } else if (documentoApp.listaArticulos[i].precioPredeterminado != null) {
          movimientoALO.precio = documentoApp.listaArticulos[i].precioPredeterminado
          movimientoALO.precioConIva = (documentoApp.listaArticulos[i].precioPredeterminado * (1 + (await this.obtenerTipoIva(documentoApp.listaArticulos[i].articulo, new Date(documentoApp.fecha)).iva / 100)))//HAY QUE CALCULARLO
        } else if (documentoApp.listaArticulos[i].precioEspecialIva != null){
          movimientoALO.precioConIva = documentoApp.listaArticulos[i].precioEspecialIva
          movimientoALO.precio = (documentoApp.listaArticulos[i].precioEspecialIva / (1 + (await this.obtenerTipoIva(documentoApp.listaArticulos[i].articulo, new Date(documentoApp.fecha)).iva / 100)))//HAY QUE CALCULARLO
        } else if (documentoApp.listaArticulos[i].precioEspecial != null) {
          movimientoALO.precio = documentoApp.listaArticulos[i].precioEspecial
          movimientoALO.precioConIva = (documentoApp.listaArticulos[i].precioEspecial * (1 + (await this.obtenerTipoIva(documentoApp.listaArticulos[i].articulo, new Date(documentoApp.fecha)).iva / 100)))//HAY QUE CALCULARLO
        }

        movimientoALO.importeDescuento1 = 0
        movimientoALO.importeDescuento2 = 0
        movimientoALO.importeDescuento3 = 0
        movimientoALO.descuentoCantidad = 0
        movimientoALO.importeDescuentoCantidad = 0
        movimientoALO.descuentoLinea = 0
        movimientoALO.importe = 0
        movimientoALO.importeConIva = 0

        documentoDTO.movimientos.push(movimientoALO);
      }else if (documentoApp.listaArticulos[i].tipoLinea == eTipoLineaMovimientos.OBSERVACIONES){
        if(this.edicionDocumento){
          movimientoALO.agentes = documentoApp.documentoALO.movimientos[i]?.agentes
        }else {
          if(this.variablesGlobales.perfilAcceso == enumPerfilAcceso.VENDEDOR){
            movimientoALO.agentes = []
            let agenteMovimientoDTO: AgenteGestionLineaDTO = new AgenteGestionLineaDTO();
            //agenteMovimientoDTO.comisionCantidad = 1;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
            //agenteMovimientoDTO.nivel = 1;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
            agenteMovimientoDTO.agente = { id: this.variablesGlobales.vendedorActual.id };
            movimientoALO.agentes.push(agenteMovimientoDTO);
          }else if (this.variablesGlobales.perfilAcceso == enumPerfilAcceso.USUARIO || this.variablesGlobales.perfilAcceso == enumPerfilAcceso.EMPRESA){
            if(this.documentoApp?.tercero?.vendedores && this.documentoApp?.tercero?.vendedores.length >0){
              movimientoALO.agentes = [];
              for (let i = 0; i < this.documentoApp?.tercero?.vendedores.length; i++) {
                let agenteMovimientoDTO: AgenteGestionLineaDTO = new AgenteGestionLineaDTO();
                //agenteMovimientoDTO.comisionCantidad = 1;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
                //agenteMovimientoDTO.nivel = 1;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
                agenteMovimientoDTO.agente = { id: this.documentoApp?.tercero?.vendedores[i]?.agente?.id };
                movimientoALO.agentes.push(agenteMovimientoDTO);
              }
            }
          }
        }

        movimientoALO.regimenFiscal = documentoApp.tercero.modalidadFiscal;
        movimientoALO.tipoMovimiento = eTipoMovimiento.SalidasClientes
        movimientoALO.tipoLinea = eTipoLineaMovimientos.OBSERVACIONES
        movimientoALO.actividad = 1;//Se pone por defecto
        movimientoALO.descripcion = documentoApp.listaArticulos[i].descripcion;
        movimientoALO.almacen = documentoApp.almacen;
        movimientoALO.unidad1 = 0
        movimientoALO.peso = 0
        movimientoALO.volumen = 0
        movimientoALO.descuento1 = 0
        movimientoALO.descuento2 = 0;
        movimientoALO.descuento3 = 0;
        movimientoALO.precio = 0
        movimientoALO.precioConIva = 0
        movimientoALO.importeDescuento1 = 0
        movimientoALO.importeDescuento2 = 0
        movimientoALO.importeDescuento3 = 0
        movimientoALO.descuentoCantidad = 0
        movimientoALO.importeDescuentoCantidad = 0
        movimientoALO.descuentoLinea = 0
        movimientoALO.importe = 0
        movimientoALO.importeConIva = 0
        documentoDTO.movimientos.push(movimientoALO);
      }


    }

    //Añadimos agentes
    if(this.edicionDocumento){
      documentoDTO.agentes = documentoApp.documentoALO?.agentes
    }else {
      if(this.variablesGlobales.perfilAcceso == enumPerfilAcceso.VENDEDOR){
        documentoDTO.agentes = []
        let agenteDocumentoALO: AgenteGestionCabeceraDTO = new AgenteGestionCabeceraDTO();
        //agenteDocumentoALO.nivel = 1;
        agenteDocumentoALO.agente = new EntidadCodigoStringDTO();
        agenteDocumentoALO.agente.id = this.variablesGlobales.vendedorActual.id;
        documentoDTO.agentes.push(agenteDocumentoALO)
      }else if (this.variablesGlobales.perfilAcceso == enumPerfilAcceso.USUARIO || this.variablesGlobales.perfilAcceso == enumPerfilAcceso.EMPRESA){
        if(this.documentoApp?.tercero?.vendedores && this.documentoApp?.tercero?.vendedores.length >0){
          documentoDTO.agentes = [];
          for (let i = 0; i < this.documentoApp?.tercero?.vendedores.length; i++) {
            let agenteMovimientoDTO: AgenteGestionLineaDTO = new AgenteGestionLineaDTO();
            agenteMovimientoDTO.comisionCantidad = 1;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
            agenteMovimientoDTO.nivel = 1;//No se que pasarle ni de donde sacarlo(los vendedores me dijo paco que iban a cambiar en ALO)
            agenteMovimientoDTO.agente = { id: this.documentoApp?.tercero?.vendedores[i]?.agente?.id };
            documentoDTO.agentes.push(agenteMovimientoDTO);
          }
        }
      }
    }


    //agenteDocumentoALO.comisionPorcentaje = 10;
    //agenteDocumentoALO.importeComisionFija = 20;

    //Añadimos cliente
    if(documentoApp.tipoOperacion == eTipoGrupo.CL){
      documentoDTO.cliente = { id: documentoApp.tercero.id };
    }else if(documentoApp.tipoOperacion == eTipoGrupo.PR){
      documentoDTO.proveedor = { id: documentoApp.tercero.id };
    }

    //Añadimos forma de pago
    documentoDTO.formaPago = { id: this.formaPagoSeleccionada?.id }

    //Añadimos sucursal
    documentoDTO.sucursal = { id: documentoApp.sucursal.id }

    //Añadimos almacen
    documentoDTO.almacen = { id: documentoApp.almacen.id }

    //Añadimos la tarifa de precios
    if(this.edicionDocumento){
      documentoDTO.tipoTarifaPrecios = documentoApp?.documentoALO?.tipoTarifaPrecios
    }else{
      if (documentoApp?.tercero?.condicionesEconomicas && documentoApp?.tercero?.condicionesEconomicas.length > 0) {
        documentoDTO.tipoTarifaPrecios = documentoApp.tercero?.condicionesEconomicas[0]?.tarifaPrecios
      }
    }


    //Añadimos la tarifa de precios
    if(this.edicionDocumento){
      documentoDTO.tipoTarifaDescuentos = documentoApp.documentoALO.tipoTarifaDescuentos
    }else{
      if (documentoApp?.tercero?.condicionesEconomicas && documentoApp?.tercero?.condicionesEconomicas.length > 0) {
        documentoDTO.tipoTarifaDescuentos = documentoApp.tercero?.condicionesEconomicas[0]?.tarifaDescuentos
      }
    }

    if(this.edicionDocumento){
      documentoDTO.datosDomicilioPrincipal = documentoApp.documentoALO.datosDomicilioPrincipal;
    }else {
      let domicilioPrincipal: DomicilioGestionDTO = new DomicilioGestionDTO();
      domicilioPrincipal.id = documentoApp.tercero.datosFiscales.domicilioFiscal.id;
      domicilioPrincipal.guidRegistro = documentoApp.tercero.datosFiscales.domicilioFiscal.guidRegistro;
      domicilioPrincipal.domicilio = documentoApp.tercero.datosFiscales.domicilioFiscal.domicilio;
      domicilioPrincipal.ampliacionDomicilio = documentoApp.tercero.datosFiscales.domicilioFiscal.ampliacionDomicilio;
      domicilioPrincipal.pais = documentoApp.tercero.datosFiscales.domicilioFiscal.pais;
      domicilioPrincipal.region = documentoApp.tercero.datosFiscales.domicilioFiscal.region;
      domicilioPrincipal.provincia = documentoApp.tercero.datosFiscales.domicilioFiscal.provincia;
      domicilioPrincipal.poblacion = documentoApp.tercero.datosFiscales.domicilioFiscal.poblacion;
      domicilioPrincipal.localidad = documentoApp.tercero.datosFiscales.domicilioFiscal.localidad;
      domicilioPrincipal.codigoPostal = documentoApp.tercero.datosFiscales.domicilioFiscal.codigoPostal;
      domicilioPrincipal.latitud = documentoApp.tercero.datosFiscales.domicilioFiscal.latitud;
      domicilioPrincipal.longitud = documentoApp.tercero.datosFiscales.domicilioFiscal.longitud;
      domicilioPrincipal.telefonos = documentoApp.tercero.telefonos;
      domicilioPrincipal.emails = documentoApp.tercero.emails;
      domicilioPrincipal.codigo = parseFloat(documentoApp.tercero.codigo);
      domicilioPrincipal.tipo = 10
      domicilioPrincipal.nombre = documentoApp.tercero.datosFiscales.nombre;
      domicilioPrincipal.razonSocial = "";
      domicilioPrincipal.nif = documentoApp.tercero.datosFiscales.nif;
      documentoDTO.datosDomicilioPrincipal = domicilioPrincipal
    }

    //Añadimos domicilio de envio
    if(this.edicionDocumento){
      documentoDTO.datosDomicilioEnvio = documentoApp.documentoALO.datosDomicilioEnvio;
    }else {
      if (documentoApp?.tercero?.domiciliosEnvio && documentoApp?.tercero?.domiciliosEnvio.length > 0) {
        let domicilioEnvio: DomicilioGestionDTO = new DomicilioGestionDTO();
        domicilioEnvio.id = documentoApp?.tercero?.domiciliosEnvio[0]?.id;
        domicilioEnvio.guidRegistro = documentoApp.tercero?.domiciliosEnvio[0]?.guidRegistro;
        domicilioEnvio.domicilio = documentoApp.tercero?.domiciliosEnvio[0]?.domicilio;
        domicilioEnvio.ampliacionDomicilio = documentoApp.tercero?.domiciliosEnvio[0]?.ampliacionDomicilio;
        domicilioEnvio.pais = documentoApp.tercero?.domiciliosEnvio[0]?.pais;
        domicilioEnvio.region = documentoApp.tercero?.domiciliosEnvio[0]?.region;
        domicilioEnvio.provincia = documentoApp.tercero?.domiciliosEnvio[0]?.provincia;
        domicilioEnvio.poblacion = documentoApp.tercero?.domiciliosEnvio[0]?.poblacion;
        domicilioEnvio.localidad = documentoApp.tercero?.domiciliosEnvio[0]?.localidad;
        domicilioEnvio.codigoPostal = documentoApp.tercero?.domiciliosEnvio[0]?.codigoPostal;
        domicilioEnvio.latitud = documentoApp.tercero?.domiciliosEnvio[0]?.latitud;
        domicilioEnvio.longitud = documentoApp.tercero?.domiciliosEnvio[0]?.longitud;
        domicilioEnvio.codigo = parseFloat(documentoApp.tercero.codigo);
        domicilioEnvio.tipo = 1
        domicilioEnvio.nombre = documentoApp.tercero?.domiciliosEnvio[0]?.nombre;
        domicilioEnvio.razonSocial = documentoApp.tercero?.domiciliosEnvio[0]?.razonSocial;
        domicilioEnvio.nif = documentoApp.tercero?.domiciliosEnvio[0]?.nif;
        documentoDTO.datosDomicilioEnvio = domicilioEnvio
      }
    }

    //Añadimos la serie
    documentoDTO.serie = { id: documentoApp.serie.id }
    return documentoDTO;

  }
  async grabarDocumentoEnAlo() {
    let loadingAlmacenar

    let documentoAloEnviar: FacturaDTO | PedidoDTO | AlbaranDTO | PresupuestoDTO
    if (this.documentoApp.tipo == enumTipoDocumento.FAC) {
      if(this.documentoApp.modalidadFactura == eTipoModalidadFacturas.Normal){
        documentoAloEnviar = new FacturaDTO();
        await this.translate.get('loadings.almacenandoFactura').toPromise().then(async (toastStr: string) => {
          loadingAlmacenar = await this.loadingCtrl.create({
            message: this.titlecasePipe.transform(toastStr),
          });
          await loadingAlmacenar.present();
        })
      }else if (this.documentoApp.modalidadFactura == eTipoModalidadFacturas.Simplificada){
        documentoAloEnviar = new FacturaSimplificadaDTO();
        await this.translate.get('loadings.almacenandoFacturaSimplificada').toPromise().then(async (toastStr: string) => {
          loadingAlmacenar = await this.loadingCtrl.create({
            message: this.titlecasePipe.transform(toastStr),
          });
          await loadingAlmacenar.present();
        })
      }
      
    } else if (this.documentoApp.tipo == enumTipoDocumento.PED) {
      documentoAloEnviar = new PedidoDTO();
      await this.translate.get('loadings.almacenandoPedido').toPromise().then(async (toastStr: string) => {
        loadingAlmacenar = await this.loadingCtrl.create({
          message: this.titlecasePipe.transform(toastStr),
        });
        await loadingAlmacenar.present();
      })
    } else if (this.documentoApp.tipo == enumTipoDocumento.ALB) {
      documentoAloEnviar = new AlbaranDTO();
      await this.translate.get('loadings.almacenandoAlbaran').toPromise().then(async (toastStr: string) => {
        loadingAlmacenar = await this.loadingCtrl.create({
          message: this.titlecasePipe.transform(toastStr),
        });
        await loadingAlmacenar.present();
      })
    } else if (this.documentoApp.tipo == enumTipoDocumento.PRE) {
      documentoAloEnviar = new PresupuestoDTO();
      await this.translate.get('loadings.almacenandoPresupuesto').toPromise().then(async (toastStr: string) => {
        loadingAlmacenar = await this.loadingCtrl.create({
          message: this.titlecasePipe.transform(toastStr),
        });
        await loadingAlmacenar.present();
      })
    }

    try {
      if (this.documentoApp.tipo == enumTipoDocumento.FAC && this.documentoApp.modalidadFactura == eTipoModalidadFacturas.Normal && this.documentoApp.tipoOperacion == eTipoGrupo.CL) {
        documentoAloEnviar = this.mapeosService.MapeoDocumentoDTOtoFacturaDTO(this.documentoDTO, eTipoGrupo.CL)
        await this.documentosErpService.postPutFacturasVenta(documentoAloEnviar as FacturaDTO).toPromise().then(async (resAM: AMRespuestaPOSTPUT) => {
          if (resAM.ok == true) {
            console.log('Factura de venta registrado correctamente! ', resAM);
            this.servicioEncriptar.eliminarLocalStorage('documentoActual')
            this.variablesGlobales.documentoActual = null
            this.variablesGlobales.documentoEnCurso = false
            await loadingAlmacenar.dismiss();
            await this.modalCtrl.dismiss();
            await this.translate.get('toast.facturaAlmacenadaCorrectamente').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'success'
              });
              await toast.present();
            })
            this.variablesGlobales.tabSeleccionadaHome = 'tabDocumentos'
            this.router.navigate(['documentos'], {state:{segmentValue:enumSegmentTipoDocumento.FAC, tipoOperacion:enumTipoOperacion.VENTA}})
          } else {
            await loadingAlmacenar.dismiss();
            console.log('Error al registrar el factura de venta. ERROR: ', resAM);
            await this.translate.get('toast.errorAlmacenarFactura').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'darnger'
              });
              await toast.present();
            })
          }
        })
          .catch(async error => {
            console.log('Error al registrar el factura de venta. ERROR: ', error);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarFactura').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'darnger'
              });
              await toast.present();
            })
          })
      } else if (this.documentoApp.tipo == enumTipoDocumento.FAC && this.documentoApp.modalidadFactura == eTipoModalidadFacturas.Normal && this.documentoApp.tipoOperacion == eTipoGrupo.PR) {
        documentoAloEnviar = this.mapeosService.MapeoDocumentoDTOtoFacturaDTO(this.documentoDTO, eTipoGrupo.PR)
        await this.documentosErpService.postPutFacturasCompra(documentoAloEnviar as FacturaDTO).toPromise().then(async (resAM: AMRespuestaPOSTPUT) => {
          if (resAM.ok == true) {
            console.log('Factura de compra registrado correctamente! ', resAM);
            this.servicioEncriptar.eliminarLocalStorage('documentoActual')
            this.variablesGlobales.documentoActual = null
            this.variablesGlobales.documentoEnCurso = false
            await loadingAlmacenar.dismiss();
            await this.modalCtrl.dismiss();
            await this.translate.get('toast.facturaAlmacenadaCorrectamente').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'success'
              });
              await toast.present();
            })
            this.variablesGlobales.tabSeleccionadaHome = 'tabDocumentosCompra'
            this.router.navigate(['documentos'], {state:{segmentValue:enumSegmentTipoDocumento.FAC, tipoOperacion:enumTipoOperacion.COMPRA}})
          } else {
            await loadingAlmacenar.dismiss();
            console.log('Error al registrar el factura de compra. ERROR: ', resAM);
            await this.translate.get('toast.errorAlmacenarFactura').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'darnger'
              });
              await toast.present();
            })
          }
        })
          .catch(async error => {
            console.log('Error al registrar el factura de compra. ERROR: ', error);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarFactura').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'darnger'
              });
              await toast.present();
            })
          })
      }else if (this.documentoApp.tipo == enumTipoDocumento.FAC && this.documentoApp.modalidadFactura == eTipoModalidadFacturas.Simplificada){
        documentoAloEnviar = this.mapeosService.MapeoDocumentoDTOtoFacturaDTO(this.documentoDTO, eTipoGrupo.CL)
        await this.documentosErpService.postPutFacturasSimplificada(documentoAloEnviar as FacturaSimplificadaDTO).toPromise().then(async (resAM: AMRespuestaPOSTPUT) => {
          if (resAM.ok == true) {
            console.log('Factura simplificada registrada correctamente! ', resAM);
            this.servicioEncriptar.eliminarLocalStorage('documentoActual')
            this.variablesGlobales.documentoActual = null
            this.variablesGlobales.documentoEnCurso = false
            await loadingAlmacenar.dismiss();
            await this.modalCtrl.dismiss();
            await this.translate.get('toast.facturaSimplificadaAlmacenadaCorrectamente').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'success'
              });
              await toast.present();
            })
            this.variablesGlobales.tabSeleccionadaHome = 'tabDocumentosVenta'
            this.router.navigate(['documentos'], {state:{segmentValue:enumSegmentTipoDocumento.FACSIM, tipoOperacion:enumTipoOperacion.VENTA}})
          } else {
            await loadingAlmacenar.dismiss();
            console.log('Error al registrar la factura simplificada. ERROR: ', resAM);
            await this.translate.get('toast.errorAlmacenarFacturaSimplificada').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'darnger'
              });
              await toast.present();
            })
          }
        })
          .catch(async error => {
            console.log('Error al registrar la factura simplificada. ERROR: ', error);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarFacturaSimplificada').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'darnger'
              });
              await toast.present();
            })
          })
      } else if (this.documentoApp.tipo == enumTipoDocumento.PED && this.documentoApp.tipoOperacion == eTipoGrupo.CL) {
        documentoAloEnviar = this.mapeosService.MapeoDocumentoDTOtoPedidoDTO(this.documentoDTO, eTipoGrupo.CL)
        console.log({documentoAloEnviar});

        await this.documentosErpService.postPutPedidosVenta(documentoAloEnviar as PedidoDTO).toPromise().then(async (resAM: AMRespuestaPOSTPUT) => {
          if (resAM.ok == true && resAM.resultadosOperaciones[0].listaRegistros[0].idRegistro) {
            console.log('Pedido de venta registrado correctamente! ', resAM);
            //AQUÍ PONER EL ESTADO DEL PEDIDO A PENDIENTE
            let estado = this.variablesGlobales.estadosPedidosALO.find(estadoPedido => estadoPedido.orden == 0)
            let estadoPedido: EstadoEntidadAsignacionDTO = {fecha: new Date(), estado: {id:estado.id}, documento: {id:resAM.resultadosOperaciones[0].listaRegistros[0].idRegistro} }
            this.documentosErpService.postPutEstadosPedidos(estadoPedido).toPromise().then(async (resAM: AMRespuestaPOSTPUT) => {})

            this.servicioEncriptar.eliminarLocalStorage('documentoActual')
            this.variablesGlobales.documentoActual = null
            this.variablesGlobales.documentoEnCurso = false
            await loadingAlmacenar.dismiss();
            await this.modalCtrl.dismiss();
            await this.translate.get('toast.pedidoAlmacenadoCorrectamente').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'success'
              });
              await toast.present();
              this.variablesGlobales.tabSeleccionadaHome = 'tabDocumentos'
              this.router.navigate(['documentos'], {state:{segmentValue:enumSegmentTipoDocumento.PED, tipoOperacion:enumTipoOperacion.VENTA}})
            })
          } else {
            console.log('Error al registrar el pedido de venta. ERROR: ', resAM);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarPedido').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'danger'
              });
              await toast.present();
            })
          }
        })
          .catch(async error => {
            console.log('Error al registrar el pedido de venta. ERROR: ', error);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarPedido').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'danger'
              });
              await toast.present();
            })
          })

      } else if (this.documentoApp.tipo == enumTipoDocumento.PED && this.documentoApp.tipoOperacion == eTipoGrupo.PR) {
        documentoAloEnviar = this.mapeosService.MapeoDocumentoDTOtoPedidoDTO(this.documentoDTO, eTipoGrupo.PR)
        console.log({documentoAloEnviar});

        await this.documentosErpService.postPutPedidosCompra(documentoAloEnviar as PedidoDTO).toPromise().then(async (resAM: AMRespuestaPOSTPUT) => {
          if (resAM.ok == true && resAM.resultadosOperaciones[0].listaRegistros[0].idRegistro) {
            console.log('Pedido de compra registrado correctamente! ', resAM);
            //AQUÍ PONER EL ESTADO DEL PEDIDO A PENDIENTE
            let estado = this.variablesGlobales.estadosPedidosALO.find(estadoPedido => estadoPedido.orden == 0)
            let estadoPedido: EstadoEntidadAsignacionDTO = {fecha: new Date(), estado: {id:estado.id}, documento: {id:resAM.resultadosOperaciones[0].listaRegistros[0].idRegistro} }
            this.documentosErpService.postPutEstadosPedidos(estadoPedido).toPromise().then(async (resAM: AMRespuestaPOSTPUT) => {})

            this.servicioEncriptar.eliminarLocalStorage('documentoActual')
            this.variablesGlobales.documentoActual = null
            this.variablesGlobales.documentoEnCurso = false
            await loadingAlmacenar.dismiss();
            await this.modalCtrl.dismiss();
            await this.translate.get('toast.pedidoAlmacenadoCorrectamente').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'success'
              });
              await toast.present();
              this.variablesGlobales.tabSeleccionadaHome = 'tabDocumentosCompra'
              this.router.navigate(['documentos'], {state:{segmentValue:enumSegmentTipoDocumento.PED, tipoOperacion:enumTipoOperacion.COMPRA}})
            })
          } else {
            console.log('Error al registrar el pedido de compra. ERROR: ', resAM);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarPedido').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'danger'
              });
              await toast.present();
            })
          }
        })
          .catch(async error => {
            console.log('Error al registrar el pedido de venta. ERROR: ', error);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarPedido').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'danger'
              });
              await toast.present();
            })
          })

      } else if (this.documentoApp.tipo == enumTipoDocumento.ALB && this.documentoApp.tipoOperacion == eTipoGrupo.CL) {
        documentoAloEnviar = this.mapeosService.MapeoDocumentoDTOtoAlbaranDTO(this.documentoDTO, eTipoGrupo.CL)
        await this.documentosErpService.postPutAlbaranesVenta(documentoAloEnviar as AlbaranDTO).toPromise().then(async (resAM: AMRespuestaPOSTPUT) => {
          if (resAM.ok == true) {
            console.log('Albarán de venta registrado correctamente! ', resAM);
            this.servicioEncriptar.eliminarLocalStorage('documentoActual')
            this.variablesGlobales.documentoActual = null
            this.variablesGlobales.documentoEnCurso = false
            await loadingAlmacenar.dismiss();
            await this.modalCtrl.dismiss();
            await this.translate.get('toast.albaranAlmacenadoCorrectamente').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'success'
              });
              await toast.present();
              this.variablesGlobales.tabSeleccionadaHome = 'tabDocumentos'
              this.router.navigate(['documentos'], {state:{segmentValue:enumSegmentTipoDocumento.ALB, tipoOperacion:enumTipoOperacion.VENTA}})
            })
          } else {
            console.log('Error al registrar el albarán de venta. ERROR: ', resAM);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarAlbaran').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'danger'
              });
              await toast.present();
            })
          }
        })
          .catch(async error => {
            console.log('Error al registrar el albarán de venta. ERROR: ', error);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarAlbaran').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'danger'
              });
              await toast.present();
            })
          })
      } else if (this.documentoApp.tipo == enumTipoDocumento.ALB && this.documentoApp.tipoOperacion == eTipoGrupo.PR) {
        documentoAloEnviar = this.mapeosService.MapeoDocumentoDTOtoAlbaranDTO(this.documentoDTO, eTipoGrupo.PR)
        await this.documentosErpService.postPutAlbaranesCompra(documentoAloEnviar as AlbaranDTO).toPromise().then(async (resAM: AMRespuestaPOSTPUT) => {
          if (resAM.ok == true) {
            console.log('Albarán de compra registrado correctamente! ', resAM);
            this.servicioEncriptar.eliminarLocalStorage('documentoActual')
            this.variablesGlobales.documentoActual = null
            this.variablesGlobales.documentoEnCurso = false
            await loadingAlmacenar.dismiss();
            await this.modalCtrl.dismiss();
            await this.translate.get('toast.albaranAlmacenadoCorrectamente').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'success'
              });
              await toast.present();
              this.variablesGlobales.tabSeleccionadaHome = 'tabDocumentosCompra'
              this.router.navigate(['documentos'], {state:{segmentValue:enumSegmentTipoDocumento.ALB, tipoOperacion:enumTipoOperacion.COMPRA}})
            })
          } else {
            console.log('Error al registrar el albarán de compra. ERROR: ', resAM);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarAlbaran').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'danger'
              });
              await toast.present();
            })
          }
        })
          .catch(async error => {
            console.log('Error al registrar el albarán de compra. ERROR: ', error);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarAlbaran').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'danger'
              });
              await toast.present();
            })
          })
      } else if (this.documentoApp.tipo == enumTipoDocumento.PRE) {
        documentoAloEnviar = this.mapeosService.MapeoDocumentoDTOtoPresupuestoDTO(this.documentoDTO)
        await this.documentosErpService.postPutPresupuestos(documentoAloEnviar as PresupuestoDTO).toPromise().then(async (resAM: AMRespuestaPOSTPUT) => {
          if (resAM.ok == true) {
            console.log('Presupuesto registrado correctamente! ', resAM);
            this.servicioEncriptar.eliminarLocalStorage('documentoActual')
            this.variablesGlobales.documentoActual = null
            this.variablesGlobales.documentoEnCurso = false
            await loadingAlmacenar.dismiss();
            await this.modalCtrl.dismiss();
            await this.translate.get('toast.presupuestoAlmacenadoCorrectamente').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'success'
              });
              await toast.present();
              this.variablesGlobales.tabSeleccionadaHome = 'tabDocumentos'
              this.router.navigate(['documentos'], {state:{segmentValue:enumSegmentTipoDocumento.PRE, tipoOperacion:enumTipoOperacion.VENTA}})
            })
          } else {
            console.log('Error al registrar el presupuesto. ERROR: ', resAM);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarPresupuesto').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'danger'
              });
              await toast.present();
            })
          }
        })
          .catch(async error => {
            console.log('Error al registrar el presupuesto. ERROR: ', error);
            await loadingAlmacenar.dismiss();
            await this.translate.get('toast.errorAlmacenarPresupuesto').toPromise().then(async (toastStr: string) => {
              const toast = await this.toastController.create({
                message: this.titlecasePipe.transform(toastStr),
                duration: 1500,
                color: 'danger'
              });
              await toast.present();
            })
          })
      }

    } catch (error) {
      console.error("Error al crear documento. ERROR: ",error);
      await loadingAlmacenar.dismiss();
      if (this.documentoApp.tipo == enumTipoDocumento.FAC) {
        await this.translate.get('toast.errorAlmacenarFactura').toPromise().then(async (toastStr: string) => {
          const toast = await this.toastController.create({
            message: this.titlecasePipe.transform(toastStr),
            duration: 1500,
            color: 'darnger'
          });
          await toast.present();
        })
      }else if (this.documentoApp.tipo == enumTipoDocumento.PED){
        await this.translate.get('toast.errorAlmacenarPedido').toPromise().then(async (toastStr: string) => {
          const toast = await this.toastController.create({
            message: this.titlecasePipe.transform(toastStr),
            duration: 1500,
            color: 'danger'
          });
          await toast.present();
        })
      }else if (this.documentoApp.tipo == enumTipoDocumento.ALB){
        await this.translate.get('toast.errorAlmacenarAlbaran').toPromise().then(async (toastStr: string) => {
          const toast = await this.toastController.create({
            message: this.titlecasePipe.transform(toastStr),
            duration: 1500,
            color: 'danger'
          });
          await toast.present();
        })
      }else if (this.documentoApp.tipo == enumTipoDocumento.PRE){
        await this.translate.get('toast.errorAlmacenarPresupuesto').toPromise().then(async (toastStr: string) => {
          const toast = await this.toastController.create({
            message: this.titlecasePipe.transform(toastStr),
            duration: 1500,
            color: 'danger'
          });
          await toast.present();
        })
      }
    }


    //console.log('Enviar documento String: ', JSON.stringify(documentoAloEnviar));



  }

  obtenerTipoIva(articulo: ArticuloDTO, fecha: Date): TiposIvaDTO {
    let tipoIvaRes: TiposIvaDTO;
    articulo.tiposIva.forEach((tipoIva: TiposIvaDTO) => {
      let fInicio: Date = new Date(tipoIva.fechaInicial);
      let fFinal: Date = new Date(tipoIva.fechaFinal);
      if ((fecha.getTime() <= fFinal.getTime() && fecha.getTime() >= fInicio.getTime()) && (articulo.tipoIva.codigo == tipoIva.codigo)) {
        tipoIvaRes = tipoIva;
        //return tipoIvaRes;
      }
    });
    //console.log('tipoIvaRes: ',tipoIvaRes);

    return tipoIvaRes;
  }

  obtenerTipoRetencion(articulo: ArticuloDTO, fecha:Date): TiposRetencionDTO {
    console.log('obtenerTipoRetencion: ', articulo);

    let tipoRetencionRes: TiposIvaDTO;
    articulo.tiposRetencion.forEach((tipoRetencion: TiposRetencionDTO) => {
      let fInicio: Date = new Date(tipoRetencion.fechaInicial);
      let fFinal: Date = new Date(tipoRetencion.fechaFinal);
      if ((fecha.getTime() <= fFinal.getTime() && fecha.getTime() >= fInicio.getTime()) && (articulo.tipoIrpf.codigo == tipoRetencion.codigo)) {
        tipoRetencionRes = tipoRetencion;
        console.log('Tipo retencion encontrada!')
        //return tipoIvaRes;
      }
    });


    return tipoRetencionRes;
  }

  anadirLineaObservaciones(){
    console.log(this.lineaObservacionesStr);
    let articulo = new ArticuloDocumentoApp();
    articulo.tipoLinea = eTipoLineaMovimientos.OBSERVACIONES;
    articulo.descripcion = this.lineaObservacionesStr;
    this.documentoApp.listaArticulos.push(articulo);
    this.lineaObservacionesStr = null;
    this.mostrarLineaObservaciones = false
    this.variablesGlobales.documentoActual = this.documentoApp
    this.actualizarDocumentoDTO();
    this.servicioEncriptar.guardarEnStorage('documentoActual', JSON.stringify(this.variablesGlobales.documentoActual));

  }

  cerrarModalListaArticulos() {
    this.seleccionarArticuloAbierto = false
  }

  async articuloSeleccionado(articuloSeleccionado) {
    console.log({articuloSeleccionado});
    this.seleccionarArticuloAbierto = false;
    this.variablesGlobales.documentoActual = this.documentoApp
    await this.actualizarDocumentoDTO();
    this.servicioEncriptar.guardarEnStorage('documentoActual', JSON.stringify(this.variablesGlobales.documentoActual));

  }

}
